(() => {
  let activeButton = null;
  let originalLabel = '';

  const getLabel = (button) => {
    return button.querySelector('.cv-quick-add-label, span:not(.loading__spinner):not(.sold-out-message)');
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.quick-add__submit, product-form [name="add"]');
    if (!button || button.disabled) return;

    activeButton = button;

    const label = getLabel(button);
    originalLabel = label ? label.textContent.trim() : '';
  });

  const showAddedFeedback = () => {
    if (!activeButton) return;

    const button = activeButton;
    const label = getLabel(button);

    if (label) {
      label.textContent = 'Added ✓';
    }

    button.classList.add('cv-added-success');

    setTimeout(() => {
      if (label && originalLabel) {
        label.textContent = originalLabel;
      }

      button.classList.remove('cv-added-success');
      activeButton = null;
      originalLabel = '';
    }, 1100);

    setTimeout(() => {
      const bubble = document.querySelector('.cart-count-bubble');

      if (bubble) {
        bubble.classList.remove('cv-bag-bump');

        requestAnimationFrame(() => {
          bubble.classList.add('cv-bag-bump');
        });

        setTimeout(() => {
          bubble.classList.remove('cv-bag-bump');
        }, 420);
      }
    }, 180);
  };

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.cartUpdate
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, showAddedFeedback);
  }
})();